import "rxjs"
import $ from "jquery"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../config"
import {
  ACTION_QUERY_COUNTRY_LIST_LOADING,
  ACTION_QUERY_COUNTRY_LIST_ERROR,
  ACTION_QUERY_COUNTRY_LIST_LOADED,
  PATH_QUERY_COUNTRIES
} from "../constants"

const api_server_host = config.api_server_host

const errorHandler = (data) => {
  const action = {
    type: ACTION_QUERY_COUNTRY_LIST_ERROR,
    payload: data
  }
  return Observable.of(action)
}

const epic = (action$, store)=>
  action$.ofType(ACTION_QUERY_COUNTRY_LIST_LOADING)
    .mergeMap(action => {

      const params = {
        lang:store.getState().locale
      }

      if(params.lang.startsWith('zh')) params.lang = 'zh_CN'

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_QUERY_COUNTRIES}?${$.param(params)}`,
        responseType: 'json'
      }).map(data=> {
        return {
          type: ACTION_QUERY_COUNTRY_LIST_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/CountriesEpic.js